import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ContentService } from '../../services/aem/content.service';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import * as AEMActions from '../actions/content.actions';

@Injectable()
export class SummaryContentEffects {
  loadSummaryContent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AEMActions.loadAEMSummaryContent),
      switchMap(() =>
        this.content.getSummaryContent().pipe(
          map((content) =>
            AEMActions.loadAEMSummaryContentSuccess({
              aemSummaryContent: {
                id: 'aem-summary-content',
                aemSummaryContent: content
              }
            })
          ),
          catchError((error: HttpErrorResponse) => {
            this.dataLayer.setErrorData(error);
            return of(
              AEMActions.loadAEMSummaryContentFailure({
                aemSummaryContentError: {
                  id: 'aem-summary-content-error',
                  aemSummaryContentError: 'full-page'
                }
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly content: ContentService,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
